export default __webpack_public_path__ + "static/media/last-ned_hvit.9748d085.svg";